const landscapesProgress = ref(0);

export function useLandscapesProgress() {
    return {
        landscapesProgress,
    };
}
